/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onUpdateProjectSub = /* GraphQL */ `subscription OnUpdateProjectSub($id: ID) {
  onUpdateProjectSub(id: $id) {
    id
    projectAccountId
    title
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    allowCreateDataPoint
    allowDataConnect
    allowCrmConnect
    allowSdkConnect
    allowSendFormData
    analyticsReportUrl
    createdAt
    dataFiles {
      fileName
      tag
      createdAt
      __typename
    }
    description
    fileName
    jsonChanges
    jsonVidUrl
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    customLoaderAssets {
      spinnerUrl
      diamondUrl
      loaderUrl
      loaderSpinnerUrl
      __typename
    }
    projectVersions {
      nextToken
      __typename
    }
    formData {
      nextToken
      __typename
    }
    settings
    stateJsonSchemaStr
    settingsJsonSchemaStr
    thumbS3Url
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    analyticsEnabled
    owner
    renders {
      nextToken
      __typename
    }
    notifications {
      nextToken
      __typename
    }
    aliasId
    minisiteConfigs {
      scenes
      title
      description
      thumbUrl
      faviconUrl
      preCreate
      __typename
    }
    playerVersionToUse
    customHtml
    dynamicThumbnails {
      name
      id
      createdAt
      updatedAt
      __typename
    }
    publishedAt
    allowedOrigins
    flowDiagram {
      __typename
    }
    nodeLayout {
      __typename
    }
    textToVideoScript
    instantiatedFromUseCase
    overlay {
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    isDeleted
    availableSceneLibraries {
      nextToken
      __typename
    }
    fontMap {
      slot
      __typename
    }
    customHooks {
      name
      description
      hookType
      code
      createdAt
      updatedAt
      __typename
    }
    crmTokens {
      selectedCrm
      hubspot
      klaviyo
      activeCampaign
      braze
      salesforceMarketingCloud
      adobeCampaign
      adobeJourneyOptimizer
      mailchimp
      marketo
      others
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProjectSubSubscriptionVariables,
  APITypes.OnUpdateProjectSubSubscription
>;
export const onUpdateProjectVersionSub = /* GraphQL */ `subscription OnUpdateProjectVersionSub($id: ID) {
  onUpdateProjectVersionSub(id: $id) {
    id
    accountOwner
    owner
    stateJsonSchemaStr
    settingsJsonSchemaStr
    settings
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    updatedAt
    playerVersionToUse
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    textToVideoScript
    flowDiagram {
      __typename
    }
    nodeLayout {
      __typename
    }
    overlay {
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    fontMap {
      slot
      __typename
    }
    customHooks {
      name
      description
      hookType
      code
      createdAt
      updatedAt
      __typename
    }
    createdAt
    projectProjectVersionsId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProjectVersionSubSubscriptionVariables,
  APITypes.OnUpdateProjectVersionSubSubscription
>;
export const onSendInstantNotification = /* GraphQL */ `subscription OnSendInstantNotification($owner: String!) {
  onSendInstantNotification(owner: $owner) {
    type
    subType
    status
    title
    message
    owner
    projectId
    extra
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnSendInstantNotificationSubscriptionVariables,
  APITypes.OnSendInstantNotificationSubscription
>;
export const onCreateNotification = /* GraphQL */ `subscription OnCreateNotification(
  $filter: ModelSubscriptionNotificationFilterInput
  $owner: String
) {
  onCreateNotification(filter: $filter, owner: $owner) {
    id
    type
    subType
    status
    title
    message
    read
    owner
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    createdAt
    extra
    updatedAt
    projectNotificationsId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateNotificationSubscriptionVariables,
  APITypes.OnCreateNotificationSubscription
>;
export const onUpdateNotification = /* GraphQL */ `subscription OnUpdateNotification(
  $filter: ModelSubscriptionNotificationFilterInput
  $owner: String
) {
  onUpdateNotification(filter: $filter, owner: $owner) {
    id
    type
    subType
    status
    title
    message
    read
    owner
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    createdAt
    extra
    updatedAt
    projectNotificationsId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateNotificationSubscriptionVariables,
  APITypes.OnUpdateNotificationSubscription
>;
export const onDeleteNotification = /* GraphQL */ `subscription OnDeleteNotification(
  $filter: ModelSubscriptionNotificationFilterInput
  $owner: String
) {
  onDeleteNotification(filter: $filter, owner: $owner) {
    id
    type
    subType
    status
    title
    message
    read
    owner
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    createdAt
    extra
    updatedAt
    projectNotificationsId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteNotificationSubscriptionVariables,
  APITypes.OnDeleteNotificationSubscription
>;
export const onCreateAccountSceneLibraries = /* GraphQL */ `subscription OnCreateAccountSceneLibraries(
  $filter: ModelSubscriptionAccountSceneLibrariesFilterInput
) {
  onCreateAccountSceneLibraries(filter: $filter) {
    id
    accountID
    sceneLibraryID
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAccountSceneLibrariesSubscriptionVariables,
  APITypes.OnCreateAccountSceneLibrariesSubscription
>;
export const onUpdateAccountSceneLibraries = /* GraphQL */ `subscription OnUpdateAccountSceneLibraries(
  $filter: ModelSubscriptionAccountSceneLibrariesFilterInput
) {
  onUpdateAccountSceneLibraries(filter: $filter) {
    id
    accountID
    sceneLibraryID
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAccountSceneLibrariesSubscriptionVariables,
  APITypes.OnUpdateAccountSceneLibrariesSubscription
>;
export const onDeleteAccountSceneLibraries = /* GraphQL */ `subscription OnDeleteAccountSceneLibraries(
  $filter: ModelSubscriptionAccountSceneLibrariesFilterInput
) {
  onDeleteAccountSceneLibraries(filter: $filter) {
    id
    accountID
    sceneLibraryID
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAccountSceneLibrariesSubscriptionVariables,
  APITypes.OnDeleteAccountSceneLibrariesSubscription
>;
export const onCreateProjectSceneLibraries = /* GraphQL */ `subscription OnCreateProjectSceneLibraries(
  $filter: ModelSubscriptionProjectSceneLibrariesFilterInput
) {
  onCreateProjectSceneLibraries(filter: $filter) {
    id
    projectID
    sceneLibraryID
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProjectSceneLibrariesSubscriptionVariables,
  APITypes.OnCreateProjectSceneLibrariesSubscription
>;
export const onUpdateProjectSceneLibraries = /* GraphQL */ `subscription OnUpdateProjectSceneLibraries(
  $filter: ModelSubscriptionProjectSceneLibrariesFilterInput
) {
  onUpdateProjectSceneLibraries(filter: $filter) {
    id
    projectID
    sceneLibraryID
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProjectSceneLibrariesSubscriptionVariables,
  APITypes.OnUpdateProjectSceneLibrariesSubscription
>;
export const onDeleteProjectSceneLibraries = /* GraphQL */ `subscription OnDeleteProjectSceneLibraries(
  $filter: ModelSubscriptionProjectSceneLibrariesFilterInput
) {
  onDeleteProjectSceneLibraries(filter: $filter) {
    id
    projectID
    sceneLibraryID
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProjectSceneLibrariesSubscriptionVariables,
  APITypes.OnDeleteProjectSceneLibrariesSubscription
>;
export const onCreateUseCaseSceneLibraries = /* GraphQL */ `subscription OnCreateUseCaseSceneLibraries(
  $filter: ModelSubscriptionUseCaseSceneLibrariesFilterInput
) {
  onCreateUseCaseSceneLibraries(filter: $filter) {
    id
    sceneLibraryID
    useCaseID
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    useCase {
      id
      name
      projectId
      images
      shortDescription
      longDescription
      thumbnail
      demoLink
      videoPreview
      lineupId
      lineupsIds
      scenes
      liveControl
      liveControlSchema
      dynamicDataSchema
      categoryId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUseCaseSceneLibrariesSubscriptionVariables,
  APITypes.OnCreateUseCaseSceneLibrariesSubscription
>;
export const onUpdateUseCaseSceneLibraries = /* GraphQL */ `subscription OnUpdateUseCaseSceneLibraries(
  $filter: ModelSubscriptionUseCaseSceneLibrariesFilterInput
) {
  onUpdateUseCaseSceneLibraries(filter: $filter) {
    id
    sceneLibraryID
    useCaseID
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    useCase {
      id
      name
      projectId
      images
      shortDescription
      longDescription
      thumbnail
      demoLink
      videoPreview
      lineupId
      lineupsIds
      scenes
      liveControl
      liveControlSchema
      dynamicDataSchema
      categoryId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUseCaseSceneLibrariesSubscriptionVariables,
  APITypes.OnUpdateUseCaseSceneLibrariesSubscription
>;
export const onDeleteUseCaseSceneLibraries = /* GraphQL */ `subscription OnDeleteUseCaseSceneLibraries(
  $filter: ModelSubscriptionUseCaseSceneLibrariesFilterInput
) {
  onDeleteUseCaseSceneLibraries(filter: $filter) {
    id
    sceneLibraryID
    useCaseID
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    useCase {
      id
      name
      projectId
      images
      shortDescription
      longDescription
      thumbnail
      demoLink
      videoPreview
      lineupId
      lineupsIds
      scenes
      liveControl
      liveControlSchema
      dynamicDataSchema
      categoryId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUseCaseSceneLibrariesSubscriptionVariables,
  APITypes.OnDeleteUseCaseSceneLibrariesSubscription
>;
